<template>
  <v-card color="white" class="rounded">
    <v-card-title class="mb-0">
      <h4 class="subheading font-weight-medium">{{ componentTitle }}</h4>
    </v-card-title>
    <v-card-text class="pt-0">
      <v-form
        v-model="formValid"
        v-on:submit.prevent="createBounty"
        ref="createBountyForm"
      >
        <v-text-field
          class="mb-3"
          v-model="newBounty.title"
          label="Title"
          :rules="requiredRules"
        ></v-text-field>
        <!-- <v-textarea
          v-model="newBounty.description"
          rows="2"
          label="Description"
          :rules="requiredRules"
        ></v-textarea> -->
        <div class="mb-4">
          <label for="description">Description</label>
          <vue-editor
            id="description"
            class="rounded"
            v-model="newBounty.description"
            placeholder="Enter description..."
            :editorOptions="editorSettings"
          />
        </div>
        <v-menu
          ref="startDateMenu"
          v-model="startDateMenu"
          :close-on-content-click="false"
          :return-value.sync="newBounty.startDate"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="newBounty.startDate"
              label="Start Date"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="newBounty.startDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="startDateMenu = false"
              >Cancel</v-btn
            >
            <v-btn
              flat
              color="primary"
              @click="$refs.startDateMenu.save(newBounty.startDate)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-menu>
        <v-menu
          ref="endDateMenu"
          v-model="endDateMenu"
          :close-on-content-click="false"
          :return-value.sync="newBounty.endDate"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="newBounty.endDate"
              label="End Date"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="newBounty.endDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="endDateMenu = false"
              >Cancel</v-btn
            >
            <v-btn
              flat
              color="primary"
              @click="$refs.endDateMenu.save(newBounty.endDate)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-menu>
        <v-flex mb-4>
          <!-- <label>Ovations Source</label> -->
          <v-radio-group
            name="ovationSource"
            v-model="ovationSource"
            hint="Select bucket to award Ovations from"
            persistent-hint
            row
          >
            <v-radio
              :label="
                'Send balance: ' + $store.state.userSelf.currentOrg.giveOvations
              "
              value="send_bucket"
            ></v-radio>
            <v-radio
              :label="
                'Redeem/Share balance: ' +
                $store.state.userSelf.currentOrg.spendOvations
              "
              value="redeem_share_bucket"
            ></v-radio>
          </v-radio-group>
        </v-flex>
        <v-text-field
          type="number"
          :rules="ovationsRules"
          :min="1"
          label="Ovations"
          v-model="newBounty.ovations"
          hint="Ovations will be awarded from the selected bucket"
          required
        ></v-text-field>
        <div
          v-if="
            isEditBounty && newBounty.fileUrl != null && newBounty.fileUrl != ''
          "
        >
          <a :href="newBounty.fileUrl" target="_blank">Existing attachment</a>
          It will be overwritten if you upload a new one.
        </div>
        <v-flex>
          <v-text-field
            label="Click here to attach document..."
            @click="onPickBountyAttachment"
            v-model="attachmentName"
          ></v-text-field>
          <!-- Hidden file input -->
          <input
            type="file"
            style="display: none"
            ref="bountyAttachmentInput"
            @change="onBountyAttachmentPicked"
          />
        </v-flex>
        <v-flex mt-4>
          <v-btn
            class="btn-rounded-medium white--text"
            color="#d13b55"
            :loading="creatingBounty"
            @click.prevent="createBounty"
            :disabled="!formValid"
            >{{ primaryButtonText }}</v-btn
          >
          <v-btn
            class="btn-rounded-medium white--text"
            color="secondary"
            @click.prevent="$emit('close', 'close')"
            :disabled="creatingBounty"
            >Cancel</v-btn
          >
        </v-flex>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";
import moment from "moment";
import validationRules from "@/js/validationRules.js";

import { VueEditor, Quill } from "vue2-editor";
window.Quill = Quill;
const ImageResize = require("quill-image-resize-module").default;
Quill.register("modules/imageResize", ImageResize);

export default {
  name: "CreateBounty",
  components: { VueEditor },
  emits: ["close"],
  props: ["bountyItem"],
  data() {
    return {
      componentTitle: "Create a new Bounty",
      primaryButtonText: "Create",
      creatingBounty: false,
      isEditBounty: false,
      startDateMenu: false,
      endDateMenu: false,
      ovationSource: "send_bucket",
      newBounty: {
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() + 7
        )
          .toISOString()
          .substr(0, 10),
      },
      editorSettings: {
        modules: {
          imageResize: {},
          toolbar: {
            container: [
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ["link", "image", "video"],
              ["clean"],
            ],
            handlers: {
              image: function () {
                var cursorLocation = this.quill.getSelection();
                var bountyImageUrl = prompt("please enter the image url here.");
                if (bountyImageUrl) {
                  this.quill.insertEmbed(
                    cursorLocation.index,
                    "image",
                    bountyImageUrl,
                    Quill.sources.USER
                  );
                }
              },
            },
          },
        },
      },
      formValid: true,
      attachmentName: "",
      attachmentUrl: "",
      attachmentSize: "",
      attachmentObject: null,
      requiredRules: validationRules.requiredRules,
      ovationsRules: validationRules.integerRules,
    };
  },
  methods: {
    onPickBountyAttachment() {
      this.$refs.bountyAttachmentInput.click();
    },
    onBountyAttachmentPicked(event) {
      const files = event.target.files;
      if (files[0] !== undefined) {
        this.attachmentName = files[0].name;
        // Check validity of file
        if (this.attachmentName.lastIndexOf(".") <= 0) {
          return;
        }

        // If valid, continue
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          // validate file size
          if (files[0].size > 5000000) {
            this.$store.commit("replaceSnackbar", {
              message: "Bounty attachment size should be less than 5 MB.",
              messageType: "warning",
            });
            this.resetAttachmentData();
            return;
          }

          this.attachmentUrl = fr.result;
          this.attachmentObject = files[0]; // this is an file that can be sent to server...
          this.attachmentName = this.attachmentObject.name;
          this.attachmentSize = this.attachmentObject.size;
          //this.formValid = true;
        });
      } else {
        this.resetAttachmentData();
      }
    },
    resetAttachmentData() {
      this.attachmentUrl = "";
      this.attachmentObject = null;
      this.attachmentName = "";
      this.attachmentSize = "";
      //this.formValid = false;
      this.$refs.bountyAttachmentInput.value = "";
    },
    createBounty() {
      // Validate title
      if (!this.newBounty.title || this.newBounty.title === "") {
        this.$store.commit("replaceSnackbar", {
          message: "Please enter a title",
          messageType: "warning",
        });
        return false;
      }

      // Validate description
      if (!this.newBounty.description || this.newBounty.description === "") {
        this.$store.commit("replaceSnackbar", {
          message: "Please enter a description",
          messageType: "warning",
        });
        return false;
      }

      // Validate start date
      var startDateIsValid = moment(
        this.newBounty.startDate,
        ["YYYY-MM-DD"],
        true
      ).isValid();

      if (!startDateIsValid) {
        this.$store.commit("replaceSnackbar", {
          message: "Invalid Start Date, Enter date in YYYY-MM-DD format",
          messageType: "warning",
        });
        return false;
      }

      // Validate end date
      var endDateIsValid = moment(
        this.newBounty.endDate,
        ["YYYY-MM-DD"],
        true
      ).isValid();

      if (!endDateIsValid) {
        this.$store.commit("replaceSnackbar", {
          message: "Invalid End Date, Enter date in YYYY-MM-DD format",
          messageType: "warning",
        });
        return false;
      }

      // Validate start date must before end date
      var sd = moment(this.newBounty.startDate);
      var ed = moment(this.newBounty.endDate);
      if (ed.diff(sd, "days") <= 0) {
        this.$store.commit("replaceSnackbar", {
          message: "End Date must be after Start Date",
          messageType: "warning",
        });
        return false;
      }

      // Validate ovations
      if (Number(this.newBounty.ovations) <= 0) {
        this.$store.commit("replaceSnackbar", {
          message: "Ovations should be a valid number & must be greater than 0",
          messageType: "warning",
        });
        return false;
      }

      // Validate ovations source buckets
      if (
        Number(this.$store.state.userSelf.currentOrg.giveOvations) === 0 &&
        Number(this.$store.state.userSelf.currentOrg.spendOvations) === 0
      ) {
        this.$store.commit("replaceSnackbar", {
          message:
            "Sorry! You don't have adequate Ovations to create a new Bounty.",
          messageType: "warning",
        });
        return false;
      }

      // Validate ovations from the selected bucket
      if (this.ovationSource === "send_bucket") {
        if (
          Number(this.newBounty.ovations) >
          Number(this.$store.state.userSelf.currentOrg.giveOvations)
        ) {
          this.$store.commit("replaceSnackbar", {
            message: "Ovations should not exceed the selected bucket balance",
            messageType: "warning",
          });
          return false;
        }
      } else if (this.ovationSource === "redeem_share_bucket") {
        if (
          Number(this.newBounty.ovations) >
          Number(this.$store.state.userSelf.currentOrg.spendOvations)
        ) {
          this.$store.commit("replaceSnackbar", {
            message: "Ovations should not exceed the selected bucket balance",
            messageType: "warning",
          });
          return false;
        }
      }

      this.formValid = false;
      this.creatingBounty = true;

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: this.isEditBounty
          ? "Updating bounty"
          : "Creating a new bounty...",
        messageType: "warning",
      });

      const params = {
        id: this.isEditBounty ? this.newBounty.id : null,
        orgId: this.$store.getters.getParentOrgIdentifier,
        title: this.newBounty.title,
        description: this.newBounty.description,
        startDate: this.newBounty.startDate,
        endDate: this.newBounty.endDate,
        ovationSource: this.ovationSource,
        ovations: parseInt(this.newBounty.ovations),
        createdAt: this.isEditBounty ? this.newBounty.createdAt : null,
        createdById: this.isEditBounty ? this.newBounty.createdById : null,
        createdByName: this.isEditBounty
          ? this.newBounty.createdByName
          : this.$store.getters.getUserFullName,
      };

      const formData = new FormData();
      formData.set("id", params.id);
      formData.set("orgId", params.orgId);
      formData.set("title", params.title);
      formData.set("description", params.description);
      formData.set("startDate", params.startDate);
      formData.set("endDate", params.endDate);
      formData.set("ovationSource", params.ovationSource);
      formData.set("ovations", params.ovations);
      formData.set("createdAt", params.createdAt);
      formData.set("createdById", params.createdById);
      formData.set("createdByName", params.createdByName);

      if (this.attachmentObject) formData.append("file", this.attachmentObject);

      // set the axios config to multipart/form-data without updating the main store version
      let localAxiosConfig = JSON.parse(
        JSON.stringify(this.$store.state.axiosConfig)
      );
      localAxiosConfig.headers["content-type"] = "multipart/form-data";

      axios
        .post("/api/bounty", formData, localAxiosConfig)
        .then((response) => {
          // Allow form submission
          this.formValid = true;
          this.creatingBounty = false;

          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: this.isEditBounty
              ? "Bounty has been updated"
              : "New Bounty has been created.",
          });

          // Reset the form
          this.$refs.createBountyForm.reset();
          this.resetAttachmentData();

          // Reset bounty object
          this.newBounty = {
            startDate: new Date().toISOString().substr(0, 10),
            endDate: new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              new Date().getDate() + 7
            )
              .toISOString()
              .substr(0, 10),
          };

          this.$emit("close", "refresh");

          // Refresh the Ovations balance
          if (response.data && response.data.userFundResult) {
            if (
              response.data.ovationSource === "send_bucket" &&
              response.data.userFundResult.unit === "giveOvation"
            ) {
              this.$store.state.userSelf.currentOrg.giveOvations =
                response.data.userFundResult.amount;
            } else if (
              response.data.ovationSource === "redeem_share_bucket" &&
              response.data.userFundResult.unit === "spendOvation"
            ) {
              this.$store.state.userSelf.currentOrg.spendOvations =
                response.data.userFundResult.amount;
            }
          }
        })
        .catch((e) => {
          // Allow form submission
          this.formValid = true;
          this.creatingBounty = false;

          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Bounty was NOT saved.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });
        });
    },
  },
  mounted() {
    if (this.bountyItem && this.bountyItem.id) {
      this.newBounty = this.bountyItem;
      this.newBounty.startDate = moment(this.newBounty.startDate).format(
        "YYYY-MM-DD"
      );
      this.newBounty.endDate = moment(this.newBounty.endDate).format(
        "YYYY-MM-DD"
      );
      this.ovationSource = this.newBounty.ovationSource;
      this.componentTitle = "Edit Bounty";
      this.primaryButtonText = "Update";
      this.isEditBounty = true;
    }
  },
};
</script>
